import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import {
  TInheritedProps,
  generateGlobalColumns,
  generateBasicColumn,
  generateEntityColumn,
  IDataGridConfig,
  generateBooleanColumn,
  SwitchColumn,
} from '@ts/storybook';
import { IConfigComponent, CChannel, CDeliveryChain } from '@ts/ui-models';
import { useAppSelector } from '@redux/store';

interface IDeliveryChainsProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'deliveryChains',
  aclId: 'DeliveryChain',
  entity: 'deliveryChain',
  fetchURL: '/api/deliveryChains',
  crudURL: '/api/deliveryChain',
  mainClass: CDeliveryChain,
};

const DeliveryChains = (props: IDeliveryChainsProps) => {
  const listACL = useAppSelector(state => state.global.aclList);
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      SwitchColumn(
        {
          field: 'state',
          headerName: 'Enabled',
          isEditable: listACL[configComponent.aclId].edit,
          dataFormat: v => v === 'ENABLED',
          dataFormatToEntity: v => (v ? 'ENABLED' : 'DISABLED'),
        },
        { field: 'state' }
        //mixProps
      ),
      globalCells.name(),
      generateEntityColumn(
        { field: 'channel', headerName: 'Inbound channel' },
        { field: 'channel', mainClass: CChannel },
        { inheritedProps }
      ),
      generateBasicColumn({ field: 'transporter' }, { field: 'transporter.name' }),
      generateBasicColumn({ field: 'forwarder' }, { field: 'forwarder.name' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default DeliveryChains;
